import { writable } from "svelte/store"

export const host = writable({})
